import { render, staticRenderFns } from "./OperationsDetail.vue?vue&type=template&id=ed38f734&scoped=true"
import script from "./OperationsDetail.vue?vue&type=script&lang=js"
export * from "./OperationsDetail.vue?vue&type=script&lang=js"
import style0 from "./OperationsDetail.vue?vue&type=style&index=0&id=ed38f734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed38f734",
  null
  
)

export default component.exports